import { render, staticRenderFns } from "./Migrator.vue?vue&type=template&id=31fc54af&scoped=true&"
import script from "./Migrator.vue?vue&type=script&lang=js&"
export * from "./Migrator.vue?vue&type=script&lang=js&"
import style0 from "./Migrator.vue?vue&type=style&index=0&id=31fc54af&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fc54af",
  null
  
)

export default component.exports